import script from "./TressSpecialAccessoriesModalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressSpecialAccessoriesModalView.vue?vue&type=script&setup=true&lang=ts"

import "./TressSpecialAccessoriesModalView.vue?vue&type=style&index=0&id=2beed04e&lang=scss"

const __exports__ = script;

export default __exports__